import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

interface AuthUserInfo {
  userType: string | null;
  uuid: string | null;
  id:number | null;
  pincode: string | null;
    token: string | null;
}

const useAuthUser = (): AuthUserInfo => {
  const authUser = useSelector((state: RootState) => state.authUser);

  const userType = authUser?.User?.user_type || null;
  const uuid = authUser?.User?.uuid || null;
  const id = authUser?.User?.id || null;
  const pincode = authUser?.User?.pincode || null;
  const token = authUser?.Token || null;
  

    return { userType, uuid, id, pincode, token };
};

export default useAuthUser;
